import { history } from '@umijs/max';
import { Button, Empty, Space, Tag, Typography } from 'antd';
import React from 'react';
import { useBusiness } from '@/prototype/context';
import type { EvidenceRef } from '@/prototype/contracts';
import EvidencePlayer from './EvidencePlayer';
export const timecode = (milliseconds: number) =>
  `${String(Math.floor(milliseconds / 60000)).padStart(2, '0')}:${String(Math.floor((milliseconds % 60000) / 1000)).padStart(2, '0')}`;
export default function EvidenceCard({ evidence }: { evidence: EvidenceRef }) {
  const { service } = useBusiness();
  const row = service?.get(evidence.recordingUuid);
  const version = row?.versions?.find(
    (v) => v.uuid === evidence.transcriptVersionUuid,
  );
  if (!row || !version)
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="来源或版本已不可访问"
      />
    );
  const text = version.segments
    .filter((s) => s.endMs > evidence.startMs && s.startMs < evidence.endMs)
    .map((s) => s.text)
    .join(' ');
  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <Typography.Text strong>{row.title}</Typography.Text>
      <Space wrap>
        <Tag>
          {timecode(evidence.startMs)}–{timecode(evidence.endMs)}
        </Tag>
        <Typography.Text type="secondary">
          转写版本 {(row.versions?.indexOf(version) ?? -1) + 1}
        </Typography.Text>
      </Space>
      <EvidencePlayer evidence={evidence} />
      <Typography.Paragraph>{text}</Typography.Paragraph>
      <Button
        onClick={() =>
          history.push(
            `/recording/${row.uuid}?startMs=${evidence.startMs}&transcriptVersionUuid=${version.uuid}`,
          )
        }
      >
        定位原始片段
      </Button>
    </Space>
  );
}
